
import { Component, Vue, Watch } from "vue-property-decorator";
import { schoolService } from "@/api/multi-tenancy/tenant";
import { organizationUnitService } from "@/api/multi-tenancy/organization-unit";
import FormBase from "@/lib/view-base/formbase";
import { CreateTenantDto, TenantDto } from "@/api/service-proxies";

import SelectTree from "@/components/SelectTree/SelectTree.vue";

@Component({
  name: "CreateTenant",
  components: {
    SelectTree,
  },
})
export default class CreateTenant extends FormBase {
  tenant = new CreateTenantDto({
    isAddMajorClass: false
  });
  schoolType = [];
  rules: object = {
    name: [ {
        validator: (rule, value, callback) => {
          if (!this.tenant.name) {
            callback(new Error('请填写学校名'));
          } else {
            callback();
          }
        },
        trigger: 'change'
      }],
    schoolType: [
       {
        validator: (rule, value, callback) => {
          if (!this.tenant.schoolType) {
            callback(new Error('请选择学校类型'));
          } else {
            callback();
          }
        },
        trigger: 'change'
      }
    ],
    position: [
      // { required: true, message: "请输入选择学校位置", trigger: "change" },
      {
        validator: (rule, value, callback) => {
          if (!this.tenant.position) {
            callback(new Error('请选择所在位置'));
          } else {
            callback();
          }
        },
        trigger: 'change'
      }
    ],
    billingType: [],
    businessType: [],
    introduction: [],
    isRegisterd: [],
    organizationUnitId: [],
  };
  updateData: TenantDto = JSON.parse(this.$route.params.row)
  businessType = 0
  billingType = 0
  businessOption = [
    { value: 0, label: '自营' },
    { value: 1, label: '代理' },
    { value: 2, label: '重点保障' }
  ]
  billingOption = [
    { value: 0, label: 'C端' },
    { value: 1, label: 'B端' },
    { value: 2, label: 'C端B端' }
  ]
  defaultProps = {
    parent: "parentId", // 父级唯一标识
    value: "id", // 唯一标识
    label: "displayName", // 标签显示
    children: "children",
  };
  options = [];
  postionEcho = { value: null, label: '' }
  mounted() {
    this.tenant.isAddMajorClass = false

    this.fetchData();
  }

  async fetchData() {
    let result = await organizationUnitService.getOrganizationUnits();
    // this.options = result;
    this.options = this.buildTree(result, null);
    if (this.updateData != -1) {
      this.tenant.position = this.updateData.position
      this.schoolType = this.updateData.schoolType ? this.updateData.schoolType.split(',') : []
      this.tenant.schoolType = this.updateData.schoolType
      this.tenant.name = this.updateData.name
      this.tenant.introduction = this.updateData.introduction
      this.tenant.organizationUnitId = this.updateData.organizationUnitId
      this.tenant.isAddMajorClass = this.updateData.isAddMajorClass
      this.postionEcho.value = this.updateData.organizationUnitId
      this.postionEcho.label = this.updateData.position
      this.tenant.id = this.updateData.id
      this.businessType=this.updateData.businessType
      this.billingType=this.updateData.billingType
    }
  }

  buildTree(data: any[], id = null) {
    const fa = (parentId) => {
      var items = data.filter((p) => p.parentId == parentId);
      let arr = [];
      items.forEach((item) => {
        arr.push({
          id: item.id,
          parentId: item.parentId,
          displayName: item.displayName,
          children: fa(item.id),
        });
      });

      return arr;
    };

    return fa(id);
  }
  organitionSelete(e: any) {
    this.tenant.position = e.label;
    this.tenant.organizationUnitId = e.value;
    this.tenant = JSON.parse(JSON.stringify(this.tenant))
  }

  created() { }

  @Watch("schoolType")
  watchSchoolType() {
    this.tenant.schoolType = this.schoolType.join(",");
  }

  async submitExecute(): Promise<void> {
    this.tenant.billingType = this.billingType
    this.tenant.businessType = this.businessType
    if (this.updateData == -1) {
      this.tenant.id=0
      await schoolService.create(this.tenant);
    } else {
      await schoolService.updateSchoolTenant(this.tenant)
    }
  }
}
